
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { TextInputLabel } from "@/components/label/TextInputLabel";
import { orderService } from "@/services/order-service2";
import { Button, Modal, Select, TextInput } from "flowbite-react";
import { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";


interface PartnerVCCancleModalProps {
  show: boolean;
  onClose: () => void;
}

interface RefundPayload {
  bank: string;
  accountNumber: string;
  accountHolder: string;
}

const PartnerVCCancleModal = ({ show, onClose }: PartnerVCCancleModalProps) => {
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const setToast = useSetRecoilState(toastState);
  const [payload, setPayload] = useState<RefundPayload>({
    bank: '',
    accountNumber: '',
    accountHolder: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPayload(prev => ({ ...prev, [name]: value }));
  };


  const isFormValid = () => {
    return (
      payload.bank.trim() &&
      payload.accountNumber.trim() &&
      payload.accountHolder.trim()
    );
  };

  const handleCancel = async () => {
    console.log(payload);
    if (!orderDetail) return
    await orderService.cancel(orderDetail.id, payload);
    const getByIdResponse = await orderService.getById(orderDetail.id);
    if (!getByIdResponse.ok) {
      return;
    }
    setOrderDetail(getByIdResponse.data);
    setToast({
      show: true,
      messages: [`발주 취소가 완료되었습니다.`],
    });
    onClose();

  }
  return (
    <Modal show={show} onClose={onClose} size="xl">
      <Modal.Header>발주 취소</Modal.Header>
      <Modal.Body>
        <div className="flex-col justify-start items-start gap-5 inline-flex overflow-hidden">
          <div className="self-stretch flex-col justify-start items-start gap-2 flex">
            <TextInputLabel required>환불받을 계좌의 은행</TextInputLabel>
            <Select
              required
              className="w-full"
              color={"black"}
              name="bank"
              value={payload.bank}
              onChange={handleChange}
            >
              <option value="">은행 선택</option>
              <option value="경남은행">경남은행</option>
              <option value="광주은행">광주은행</option>
              <option value="단위농협(지역농축협)">단위농협(지역농축협)</option>
              <option value="부산은행">부산은행</option>
              <option value="새마을금고">새마을금고</option>
              <option value="산림조합">산림조합</option>
              <option value="신한은행">신한은행</option>
              <option value="신협">신협</option>
              <option value="씨티은행">씨티은행</option>
              <option value="우리은행">우리은행</option>
              <option value="우체국예금보험">우체국예금보험</option>
              <option value="저축은행중앙회">저축은행중앙회</option>
              <option value="전북은행">전북은행</option>
              <option value="제주은행">제주은행</option>
              <option value="카카오뱅크">카카오뱅크</option>
              <option value="케이뱅크">케이뱅크</option>
              <option value="토스뱅크">토스뱅크</option>
              <option value="하나은행">하나은행</option>
              <option value="DGB대구은행">DGB대구은행</option>
              <option value="IBK기업은행">IBK기업은행</option>
              <option value="KB국민은행">KB국민은행</option>
              <option value="KDB산업은행">KDB산업은행</option>
              <option value="NH농협은행">NH농협은행</option>
              <option value="SC제일은행">SC제일은행</option>
              <option value="Sh수협은행">Sh수협은행</option>
            </Select>
          </div>
          <div className="self-stretch flex-col justify-start items-start gap-2 flex">
            <TextInputLabel required>환불받을 계좌번호</TextInputLabel>
            <TextInput
              required
              className="w-full"
              placeholder="환불받을 계좌번호 입력"
              name="accountNumber"
              value={payload.accountNumber}
              onChange={handleChange}
            />
            <div className="self-stretch text-[#1c304a]/50 text-sm font-normal font-['Pretendard'] leading-snug">‘-’ 없이 번호만 입력해주세요.</div>
          </div>
          <div className="self-stretch flex-col justify-start items-start gap-2 flex">
            <TextInputLabel required>환불받을 계좌 예금주명</TextInputLabel>
            <TextInput
              required
              className="w-full"
              placeholder="환불받을 계좌 예금주명 입력"
              name="accountHolder"
              value={payload.accountHolder}
              onChange={handleChange}
            />
            <div className="self-stretch text-[#1c304a]/50 text-sm font-normal font-['Pretendard'] leading-snug">정확한 예금주명을 입력해주세요.</div>
          </div>

          <div className="self-stretch px-3 py-4 bg-[#f8f8f9] rounded-lg border border-[#1c375a]/20 flex-col justify-start items-start gap-3 flex">
            <div className="self-stretch justify-start items-center gap-1 inline-flex">
              <div className="text-[#192434] text-base font-semibold font-['Pretendard'] leading-normal">알아두세요!</div>
            </div>
            <div className="self-stretch text-[#18273a]/95 text-sm font-normal font-['Pretendard'] leading-snug">결제가 완료된 발주건을 취소할 경우 접수 이후 영업일 기준 7일 이내로 정상 환불 처리됩니다.</div>
          </div>
          <Button
            color={!isFormValid() ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
            className="w-full"
            disabled={!isFormValid()}
            onClick={handleCancel}
          >
            발주 취소하기
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PartnerVCCancleModal;
